import { useEffect } from "react";
import { usePostsExample } from "hooks/usePostsExample";

export const useExample = () => {
  const { fetchAllPosts, posts, isLoading, error, clear } = usePostsExample();

  useEffect(() => {
    fetchAllPosts();

    return () => {
      clear()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    isLoading,
    posts,
    error,
  };
};
